// extracted by mini-css-extract-plugin
export default {"group":"Heart_group__uQ8IM","heart":"Heart_heart__0QKyr"};